import { useState } from 'react';
import { detalleAviso, type DetalleAviso } from './api-panel';

/**
 * Los números de un aviso en una línea: cuántas cosas hay que tocar, desde cuándo y cuántas veces
 * se reportó; el que no aplica se omite (un insumo en negativo no tiene antigüedad). La unidad la
 * manda la base (`texto_aviso`); «Sin avisar hasta hoy» se muestra como texto, no como cero.
 */
export function resumenDeAviso(a: {
  pendientes: number;
  antiguedadDias: number | null;
  avisos: number;
  unidad: string;
}): string {
  const partes = [`${a.pendientes} ${a.unidad}${a.pendientes === 1 ? '' : 's'}`];
  if (a.antiguedadDias !== null && a.antiguedadDias > 0) {
    partes.push(`el más viejo hace ${a.antiguedadDias} día${a.antiguedadDias === 1 ? '' : 's'}`);
  }
  partes.push(a.avisos > 0 ? `avisado ${a.avisos} ${a.avisos === 1 ? 'vez' : 'veces'}` : 'sin avisar hasta hoy');
  return partes.join(' · ');
}

/**
 * El desplegable de un aviso: la lista se pide al abrirlo y se queda. Son cinco tipos por negocio y
 * casi ninguno se mira, así que no se traen por adelantado.
 */
export function useDetalleAviso(negocioId: string, tipo: string) {
  const [abierto, setAbierto] = useState(false);
  const [detalle, setDetalle] = useState<DetalleAviso[] | null>(null);
  const [error, setError] = useState('');

  function alternar() {
    setAbierto((v) => !v);
    if (detalle !== null || abierto) return;
    detalleAviso(negocioId, tipo)
      .then(setDetalle)
      .catch((e) => setError(e instanceof Error ? e.message : 'No pudimos leer el detalle.'));
  }

  return { abierto, detalle, error, alternar };
}
